import { DELETE_UNDO_SECONDS } from "../../model/commandeListRules";

const MENU_ITEM_STYLE = {
    display: "block", width: "100%", textAlign: "left",
    padding: "10px 14px", background: "none", border: "none",
    cursor: "pointer", fontSize: "13px",
};

function MenuItem({ color, hoverBackground, onClick, children }) {
    return (
        <button
            onClick={onClick}
            style={{ ...MENU_ITEM_STYLE, color }}
            onMouseEnter={e => e.currentTarget.style.background = hoverBackground}
            onMouseLeave={e => e.currentTarget.style.background = "none"}
        >
            {children}
        </button>
    );
}

// Menu du clic droit : bascule lu / non lu et suppression.
export function CommandeContextMenu({ contextMenu, isRead, onToggleRead, onDelete }) {
    if (!contextMenu) return null;
    return (
        <div
            onMouseDown={e => e.stopPropagation()}
            style={{
                position: "fixed",
                top: contextMenu.y,
                left: contextMenu.x,
                background: "white",
                borderRadius: "8px",
                boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
                border: "1px solid #e2e8f0",
                zIndex: 2000,
                minWidth: "180px",
                overflow: "hidden",
            }}
        >
            <MenuItem color="#334155" hoverBackground="#f8fafc" onClick={onToggleRead}>
                {isRead ? "Marquer comme non lu" : "Marquer comme lu"}
            </MenuItem>
            <div style={{ height: "1px", background: "#f1f5f9", margin: "2px 0" }} />
            <MenuItem color="#dc2626" hoverBackground="#fef2f2" onClick={onDelete}>
                Supprimer
            </MenuItem>
        </div>
    );
}

function DeleteToast({ item, onCancel }) {
    return (
        <div style={{
            background: "#1e293b",
            color: "white",
            borderRadius: "10px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.25)",
            overflow: "hidden",
        }}>
            <div style={{ padding: "14px 16px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "16px" }}>
                <span style={{ fontSize: "13px" }}>
                    Mail supprimé — {item.secondsLeft}s pour annuler
                </span>
                <button
                    onClick={() => onCancel(item.cmd.id)}
                    style={{
                        background: "none",
                        border: "1px solid rgba(255,255,255,0.3)",
                        borderRadius: "6px",
                        color: "white",
                        padding: "4px 12px",
                        fontSize: "13px",
                        fontWeight: 600,
                        cursor: "pointer",
                        flexShrink: 0,
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.1)"}
                    onMouseLeave={e => e.currentTarget.style.background = "none"}
                >
                    Annuler
                </button>
            </div>
            <div style={{ height: "3px", background: "rgba(255,255,255,0.15)" }}>
                <div style={{
                    height: "100%",
                    background: "#60a5fa",
                    width: `${(item.secondsLeft / DELETE_UNDO_SECONDS) * 100}%`,
                    transition: "width 0.9s linear",
                }} />
            </div>
        </div>
    );
}

// Toasts des suppressions en attente, chacun avec son compte à rebours et son bouton d'annulation.
export function CommandeDeleteToasts({ pendingDeletes, onCancel }) {
    if (pendingDeletes.length === 0) return null;
    return (
        <div style={{
            position: "fixed",
            bottom: "24px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 3000,
            minWidth: "340px",
            maxWidth: "90vw",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
        }}>
            {pendingDeletes.map(item => (
                <DeleteToast key={item.cmd.id} item={item} onCancel={onCancel} />
            ))}
        </div>
    );
}
